import { ChangeDetectionStrategy, Component, Input,  } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Hostel, Review } from '@app/services/api/api.service';

@Component({
  selector: 'app-votes',
  templateUrl: './votes.component.html',
  styleUrls: ['./votes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class VotesComponent {
  @Input()
  hostel?: Hostel;
@Input() overallRating: number;

@Input() totalReviews: number;

  public ratings: any = [];
  public badges: any = [];

  public top4Badges: any[] = [];

  public randomTravelers: number;

  constructor() {
    this.randomTravelers = this.getRandomInt(2, 12);
  }

  private getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  get roundedCombinedRating(): number {
    return Math.floor(this.overallRating ?? 0); // Use Math.floor to round down
  }
  

  ngOnChanges() {
    if (this.hostel) {
      this.countVotes(this.hostel.reviews ?? [], this.hostel.google_review_data?.reviews_per_score ?? {});

      this.top4Badges = this.badges.slice(0, 4);
    }
  }

  private countVotes(reviews: Review[], googleReviews: any) {
    const badges: any = {};
    const ratings: any = {
      '10': { count: 0 },
      '9': { count: 0 },
      '8': { count: 0 },
      '7': { count: 0 },
      '6': { count: 0 },
      '5': { count: 0 },
      '4': { count: 0 },
      '3': { count: 0 },
      '2': { count: 0 },
      '1': { count: 0 },
    };
  
    // Count hostel reviews
    reviews.forEach((review) => {
      const rating = String(review.rating);
      if (ratings[rating]) {
        ratings[rating].count++;
      } else {
        ratings[rating] = {
          count: 1,
        };
      }
  
      review.badges.forEach((badge) => {
        const badgeName = badge.name;
        if (badges[badgeName]) {
          badges[badgeName].count++;
        } else {
          badges[badgeName] = {
            count: 1,
            icon: badge.icon,
          };
        }
      });
    });

    // Count Google reviews and calculate the total number of Google reviews
    let googleReviewTotalCount = 0;
    Object.keys(googleReviews).forEach((score) => {
      const count = googleReviews[score];
      googleReviewTotalCount += count; // Add to the total Google review count
      const adjustedScore = String(Number(score) * 2); // Multiply score by 2
      if (ratings[adjustedScore]) {
        ratings[adjustedScore].count += count;
      } else {
        ratings[adjustedScore] = {
          count: count,
        };
      }
    });

    // Combine the total number of hostel and Google reviews
    const totalReviewsCount = reviews.length + googleReviewTotalCount;
  
    this.ratings = Object.keys(ratings)
      .reduce((acc, cv) => {
        acc.push({
          score: cv,
          percentage: (ratings[cv].count / totalReviewsCount) * 100, // Use combined total for percentage
        });
        return acc;
      }, [] as any[])
      .sort((a, b) => {
        return b.score - a.score;
      });
  
    this.badges = Object.keys(badges)
      .reduce((acc, cv) => {
        acc.push({
          name: cv,
          count: badges[cv].count,
          icon: badges[cv].icon,
        });
        return acc;
      }, [] as any[])
      .sort((a, b) => {
        return b.count - a.count;
      }).slice(0, 8);
  }

  public hasBadges(): boolean {
    return this.badges.length > 0;
  }
}
